import { render } from "./UserCreatedTrimsTab.vue?vue&type=template&id=7b670f68"
import script from "./UserCreatedTrimsTab.vue?vue&type=script&lang=js"
export * from "./UserCreatedTrimsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__